// Header.jsx
import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../Styles/Header.scss";
import Logo from "../Image/logo.png";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { t, i18n } = useTranslation();

  // Scroll to top function
  const openToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  // Change language
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setMenuOpen(false); // close menu on mobile after selection
  };

  return ( 
    <header className="header">
      <div className="container">
        {/* Logo */}
        <NavLink
          to="/"
          className="logo-link"
          onClick={() => {
            openToTop();
            setMenuOpen(false);
          }}
        >
          <div className="logo">
            <img src={Logo} width={140} height={40} alt="navbar header"/>
          </div>
        </NavLink>

        {/* Navigation Menu */}
        <nav className={`nav ${menuOpen ? "open" : ""}`}>
          <NavLink
            to="/"
            onClick={() => {
              openToTop();
              setMenuOpen(false);
            }}
          >
            {t("home")}
          </NavLink>
          <NavLink
            to="/services"
            onClick={() => {
              openToTop();
              setMenuOpen(false);
            }}
          >
            {t("services")}
          </NavLink>
          <NavLink
            to="/projects"
            onClick={() => {
              openToTop();
              setMenuOpen(false);
            }}
          >
            {t("projects")}
          </NavLink>
          <NavLink
            to="/about"
            onClick={() => {
              openToTop();
              setMenuOpen(false);
            }}
          >
            {t("about")}
          </NavLink>
          <NavLink
            to="/contact"
            onClick={() => {
              openToTop();
              setMenuOpen(false);
            }}
          >
            {t("contact")}
          </NavLink>

          {/* Language Switcher inside nav for mobile */}
          <div className="language-switcher">
            <button onClick={() => changeLanguage("de")}>DE</button>
            <button onClick={() => changeLanguage("en")}>EN</button>
          </div>
        </nav>

        {/* Hamburger for mobile */}
        <div
          className={`hamburger ${menuOpen ? "active" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </header>
  );
};

export default Header;


// import { NavLink } from "react-router-dom";
// import { useState } from "react";
// import "../Styles/Header.scss";
// import { useTranslation } from "react-i18next";

// const { t, i18n } = useTranslation();
// const changeLanguage = (lng) => {
//   i18n.changeLanguage(lng);
// };

// const Header = () => {
//   const [menuOpen, setMenuOpen] = useState(false);
//   const openToTop = () => {
//     window.scrollTo({
//       top: 0,
//       left: 0,
//       behavior: "smooth",
//     });
//   };
//   return (
//     // <header className="header">
//     //   <div className="container">
//     //     <NavLink
//     //       to="/"
//     //       className="logo-link"
//     //       onClick={() => {
//     //         openToTop();
//     //         setMenuOpen(false);
//     //       }}
//     //     >
//     //       {" "}
//     //       <div className="logo">emibau</div>
//     //     </NavLink>

//     //     <nav className={`nav ${menuOpen ? "open" : ""}`}>
//     //       <NavLink
//     //         to="/"
//     //         onClick={() => {
//     //           openToTop();
//     //           setMenuOpen(false);
//     //         }}
//     //       >
//     //         Home
//     //       </NavLink>
//     //       <NavLink
//     //         to="/services"
//     //         onClick={() => {
//     //           openToTop();
//     //           setMenuOpen(false);
//     //         }}
//     //       >
//     //         Services
//     //       </NavLink>
//     //       <NavLink
//     //         to="/projects"
//     //         onClick={() => {
//     //           openToTop();
//     //           setMenuOpen(false);
//     //         }}
//     //       >
//     //         Projects
//     //       </NavLink>
//     //       <NavLink
//     //         to="/about"
//     //         onClick={() => {
//     //           openToTop();
//     //           setMenuOpen(false);
//     //         }}
//     //       >
//     //         About
//     //       </NavLink>
//     //       <NavLink
//     //         to="/contact"
//     //         onClick={() => {
//     //           openToTop();
//     //           setMenuOpen(false);
//     //         }}
//     //       >
//     //         Contact Us
//     //       </NavLink>
//     //     </nav>

//     //     <div
//     //       className={`hamburger ${menuOpen ? "active" : ""}`}
//     //       onClick={() => setMenuOpen(!menuOpen)}
//     //     >
//     //       <span></span>
//     //       <span></span>
//     //       <span></span>
//     //     </div>
//     //   </div>
//     // </header>
//     <header className="header">
//       <div className="container">
//         <NavLink
//           to="/"
//           className="logo-link"
//           onClick={() => {
//             openToTop();
//             setMenuOpen(false);
//           }}
//         >
//           <div className="logo">emibau</div>
//         </NavLink>

//         <nav className={`nav ${menuOpen ? "open" : ""}`}>
//           <NavLink
//             to="/"
//             onClick={() => {
//               openToTop();
//               setMenuOpen(false);
//             }}
//           >
//             {t("home")}
//           </NavLink>
//           <NavLink
//             to="/services"
//             onClick={() => {
//               openToTop();
//               setMenuOpen(false);
//             }}
//           >
//             {t("services")}
//           </NavLink>
//           <NavLink
//             to="/projects"
//             onClick={() => {
//               openToTop();
//               setMenuOpen(false);
//             }}
//           >
//             {t("projects")}
//           </NavLink>
//           <NavLink
//             to="/about"
//             onClick={() => {
//               openToTop();
//               setMenuOpen(false);
//             }}
//           >
//             {t("about")}
//           </NavLink>
//           <NavLink
//             to="/contact"
//             onClick={() => {
//               openToTop();
//               setMenuOpen(false);
//             }}
//           >
//             {t("contact")}
//           </NavLink>

//           <div className="language-switcher">
//             <button onClick={() => changeLanguage("de")}>DE</button>
//             <button onClick={() => changeLanguage("en")}>EN</button>
//           </div>
//         </nav>

//         <div
//           className={`hamburger ${menuOpen ? "active" : ""}`}
//           onClick={() => setMenuOpen(!menuOpen)}
//         >
//           <span></span>
//           <span></span>
//           <span></span>
//         </div>
//       </div>
//     </header>
//   );
// };

// export default Header;
